import { mediaQueryLarge, isMobileBreakpoint } from '@theme/utilities';

document.addEventListener('DOMContentLoaded', () => {
  class AccordionCustom extends HTMLElement {
    get details() {
      const details = this.querySelector('details');
      if (!(details instanceof HTMLDetailsElement)) throw new Error('Details element not found');
      return details;
    }

    get summary() {
      const summary = this.details.querySelector('summary');
      if (!(summary instanceof HTMLElement)) throw new Error('Summary element not found');
      return summary;
    }

    get #disableOnMobile() {
      return this.dataset.disableOnMobile === 'true';
    }

    get #disableOnDesktop() {
      return this.dataset.disableOnDesktop === 'true';
    }

    get #closeWithEscape() {
      return this.dataset.closeWithEscape === 'true';
    }

    #controller = new AbortController();

    connectedCallback() {
      const { signal } = this.#controller;

      this.#setDefaultOpenState();

      this.addEventListener('keydown', this.#handleKeyDown, { signal });
      this.summary.addEventListener('click', this.handleClick, { signal });
      mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange, { signal });
    }

    disconnectedCallback() {
      this.#controller.abort();
    }

    handleClick = (event) => {
      const isMobile = isMobileBreakpoint();
      const isDesktop = !isMobile;

      if ((isMobile && this.#disableOnMobile) || (isDesktop && this.#disableOnDesktop)) {
        event.preventDefault();
        return;
      }

      
      if (this.closest('.open_one_only')) {
        const allAccordions = document.querySelectorAll('accordion-custom');
        allAccordions.forEach((accordion) => {
          if (accordion !== this) {
            const otherDetails = accordion.querySelector('details');
            if (otherDetails && otherDetails.open) {
              otherDetails.open = false;
            }
          }
        });
      }
    };

    #handleMediaQueryChange = () => {
      this.#setDefaultOpenState();
    };

    #setDefaultOpenState() {
      const isMobile = isMobileBreakpoint();
      this.details.open =
        (isMobile && this.hasAttribute('open-by-default-on-mobile')) ||
        (!isMobile && this.hasAttribute('open-by-default-on-desktop'));
    }

    #handleKeyDown(event) {
      if (event.key === 'Escape' && this.#closeWithEscape) {
        event.preventDefault();
        this.details.open = false;
        this.summary.focus();
      }
    }
  }

  
  if (!customElements.get('accordion-custom')) {
    customElements.define('accordion-custom', AccordionCustom);
  }

  
  if (isMobileBreakpoint()) {
    const targetAccordion = document.querySelector(
      'accordion-custom.custom-accordion-open[data-disable-on-desktop="true"][open-by-default-on-desktop]'
    );
    if (targetAccordion) {
      const detailsEl = targetAccordion.querySelector('details');
      if (detailsEl) {
        detailsEl.setAttribute('open', '');
      }
    }
  }
});
